import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import BespokeWizard from "@/components/bespoke/BespokeWizard";

// Default measurements for admin-added garments (upper-body oriented, e.g.
// blazers/jackets/waistcoats). The bespoke option sections themselves are
// fully dynamic — configured per garment in Admin → Bespoke → Bespoke Options.
const DEFAULT_MEASURE_FIELDS = [
  { key: "body_height", label: "Body Height *", type: "text", target: "style", required: true },
  { key: "chest", label: "Chest (in) *", target: "meas", required: true },
  { key: "waist", label: "Waist (in) *", target: "meas", required: true },
  { key: "shoulder", label: "Shoulder (in)", target: "meas" },
  { key: "sleeve_length", label: "Sleeve Length (in)", target: "meas" },
];

export default function BespokeGeneric() {
  const { key } = useParams();
  const [cat, setCat] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/bespoke-categories")
      .then(({ data }) => { setCat((data || []).find((c) => c.key === key) || null); })
      .catch(() => setCat(null))
      .finally(() => setLoading(false));
  }, [key]);

  if (loading) return <main className="sq-container py-24" data-testid="bespoke-generic-loading" />;

  if (!cat) {
    return (
      <main className="sq-container py-24 text-center" data-testid="bespoke-generic-not-found">
        <h1 className="font-display text-4xl">Category not found</h1>
        <p className="text-[#4B5563] mt-3">This bespoke category doesn't exist or was removed.</p>
        <Link to="/bespoke" className="sq-btn-primary inline-flex mt-6">Back to Bespoke</Link>
      </main>
    );
  }

  // Standard sizes (upper-body) so admin garments like Blazer get the
  // "Customized For You / Standard Size" choice like the dedicated pages.
  const config = {
    garmentType: cat.key,
    title: cat.label || cat.hub_label || "Bespoke",
    prefix: cat.key,
    guideCaption: cat.description || "For the best fit, measure from a garment that fits you well.",
    faqs: cat.faqs || [],
    groups: [],
    measureFields: DEFAULT_MEASURE_FIELDS,
    sizes: ["S", "M", "L", "XL", "XXL", "3XL", "4XL", "5XL"],
    sizeChart: {
      columns: ["Chest (in)", "Front Length (in)", "Sleeves (in)", "Across Shoulder (in)"],
      rows: [
        { size: "S", values: [38, 28, 24, 17] },
        { size: "M", values: [40, 28.5, 24.5, 17.5] },
        { size: "L", values: [42, 29, 25, 18] },
        { size: "XL", values: [44, 29.5, 25.5, 18.5] },
        { size: "XXL", values: [46, 30, 25.5, 19] },
        { size: "3XL", values: [48, 30.5, 26, 19.5] },
        { size: "4XL", values: [50, 31, 26, 20] },
        { size: "5XL", values: [52, 31, 26, 20.5] },
      ],
    },
  };

  return <BespokeWizard config={config} />;
}
